import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { fundraisingService } from '../../services/fundraisingService';

export const useGetFounderFundraisingStatus = founderId => {
  return useQuery({
    enabled: !!founderId,
    staleTime: 1000 * 60,
    queryKey: [QUERY_KEYS.fundraising.founder_fr_status, founderId],
    queryFn: () =>
      fundraisingService.founderFundraisingStatus(founderId).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
